// @ts-nocheck
import useAccount from "classes/Accounts/hooks/useAccount";
import CategoryObject from "classes/Categories/CategoryObject";
import { ConditionalSelect } from "components/Inputs/CustomAsyncSelect/CustomCreatableSelect";
import genRequest from "includes/request";
import { t } from "i18next";
import React from "react";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";

export default function CategoriesSelect(props) {
	const { isAdmin } = useAccount();
	const isMobile = useMediaQuery({ query: "(max-width: 700px)" });

	function handleAdd(cat) {
		let obj = new CategoryObject({
			name: cat.label,
			categoryType: props.type,
			description: "",
			companyId: props.companyId,
		});
		let req = obj.send().then((resp) => {
			// CategoryObject.values() returns { categoryId, categoryName, ... },
			// not { id, name }. Reading the wrong keys produced an option with
			// label: undefined / value: undefined, so the new chip displayed
			// empty and could not be matched against the dropdown listing.
			let ret = {
				label: resp.categoryName ?? resp.name,
				value: resp.categoryId ?? resp.id,
			};
			if (props.onCreate) props.onCreate(ret);
			return ret;
		});
		return req;
	}

	return (
		<div
			className={
				"categories-drop-cont" + clsx(isMobile && " mobile") +
				(props.className ? ` ${props.className}` : "") +
				" mt-2"
			}
		>
			{!props.noTitle && <div className="title-form">{t("Commons.CATEGORIES")}</div>}
			<ConditionalSelect
				placeholder={t("Commons.SELECT_CATEGORIES")}
				classNamePrefix="dropdown"
				queryKey={[
					"Categories",
					"CompanyTyped",
					props.companyId,
					props.type,
				]}
				queryFn={() =>
					genRequest(
						"categories/company/" +
						props.companyId +
						"/type/" +
						props.type
					)
				}
				treat={(cat) => ({
					...cat,
					value: cat.id,
					label: cat.categoryName,
					color: cat.categoryColor,
				})}
				isMulti={true}
				isSearchable={true}
				closeMenuOnSelect={false}
				onCreateOption={isAdmin() ? handleAdd : false}
				{...props}
				className={"bg-color w-100 rounded"}
			/>
		</div>
	);
}
